import queryString from 'query-string'

import {
  SEARCH,
  SEARCH_BLUR,
  SEARCH_FOCUS,
  SEARCH_SUCCESS,
  SET_AVAILABLE,
  LOCATION_CHANGE,
  LOG_OUT_SUCCESS,
} from 'actionTypes'

const initialState = {
  query: '',
  focus: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT_SUCCESS:
      return initialState
    case LOCATION_CHANGE:
      const searchQuery = queryString.parse(action.payload.search)
      return {
        ...state,
        query: searchQuery.query,
      }
    case SEARCH:
      return {
        ...state,
        query: action.query,
        focus: false,
        results: {
          ...state.results,
          [action.query]: 'pending',
        },
      }
    case SEARCH_SUCCESS:
      return {
        ...state,
        results: {
          ...state.results,
          [action.query]: action.results,
        },
      }
    case SET_AVAILABLE:
      return {
        ...state,
        available: action.available,
      }
    case SEARCH_BLUR:
      return {
        ...state,
        focus: false,
      }
    case SEARCH_FOCUS:
      return {
        ...state,
        focus: true,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/search.js